module.exports = __webpack_public_path__ + "static/media/clock-circle.1b3dd0c7.png";